import RuleBodyPage from "components/common/RuleBodyPage";
import { RuleModalBodyProps } from "components/common/RuleModal";
import { useTranslation } from "react-i18next";

function WhosTheBotRuleBody({ page }: RuleModalBodyProps) {
  const { t } = useTranslation();
  const phaseContainer =
    "flex items-center gap-3 p-3 bg-gray-800 rounded-lg mb-4";
  const iconContainer =
    "w-8 h-8 min-w-9 min-h-9 flex items-center justify-center rounded-full text-sm";
  const rules = t("WTB.rules", { returnObjects: true }) as string[];

  return (
    <div className="relative flex">
      {/* Page 1: 게임 소개 및 기본 규칙 */}
      <RuleBodyPage show={page === 0}>
        <div className="space-y-4">
          <div className="text-gray-100">{rules[0]}</div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-indigo-600`}>
              <i className="fas fa-robot" />
            </div>
            <div>
              <div className="font-medium text-indigo-300 mb-1">
                {t("aiPlayer")}
              </div>
              <div className="text-sm text-gray-300">{rules[1]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-blue-600`}>
              <i className="fas fa-users" />
            </div>
            <div>
              <div className="font-medium text-blue-300 mb-1">
                {t("WTB.humanPlayer")}
              </div>
              <div className="text-sm text-gray-300">{rules[2]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 2: 게임 진행 단계 */}
      <RuleBodyPage show={page === 1}>
        <div className="text-xl font-bold text-indigo-400 mb-4">
          {t("WTB.gamePhases")}
        </div>
        <div className="space-y-4">
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-green-600`}>
              <i className="fas fa-pen" />
            </div>
            <div>
              <div className="font-medium text-green-300 mb-1">
                {t("WTB.answerPhase")}
              </div>
              <div className="text-sm text-gray-300">{rules[3]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-yellow-600`}>
              <i className="fas fa-vote-yea" />
            </div>
            <div>
              <div className="font-medium text-yellow-300 mb-1">
                {t("WTB.votingPhase")}
              </div>
              <div className="text-sm text-gray-300">{rules[4]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-red-600`}>
              <i className="fas fa-robot" />
            </div>
            <div>
              <div className="font-medium text-red-300 mb-1">
                {t("WTB.aiVotingPhase")}
              </div>
              <div className="text-sm text-gray-300">{rules[5]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 3: 점수 및 팁 */}
      <RuleBodyPage show={page === 2}>
        <div className="space-y-4">
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-purple-600`}>
              <i className="fas fa-star" />
            </div>
            <div>
              <div className="font-medium text-purple-300 mb-1">
                {t("WTB.scoringSystem")}
              </div>
              <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
                <li>{rules[6]}</li>
                <li>{rules[7]}</li>
                <li>{rules[8]}</li>
              </ul>
            </div>
          </div>
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-indigo-300 mb-2">
              {t("WTB.successTips")}
            </div>
            <ul className="list-disc list-inside space-y-2 text-sm text-gray-300">
              <li>{rules[9]}</li>
              {/* <li>{rules[10]}</li> */}
              {/* <li>{rules[11]}</li> */}
            </ul>
          </div>
        </div>
      </RuleBodyPage>
    </div>
  );
}

export default WhosTheBotRuleBody;
